module.exports = "/_next/static/images/d2c2c8995c7679a5d2971dbc45dfaa56-cards@2x.png.webp";